export const countryCenter: Record<string, { lat: number, lng: number }> = {
  AND: { lat: 42.546245, lng: 1.601554 },
  ARE: { lat: 23.424076, lng: 53.847818 },
  AFG: { lat: 33.93911, lng: 67.709953 },
  ATG: { lat: 17.060816, lng: -61.796428 },
  AIA: { lat: 18.220554, lng: -63.068615 },
  ALB: { lat: 41.153332, lng: 20.168331 },
  ARM: { lat: 40.069099, lng: 45.038189 },
  AGO: { lat: -11.202692, lng: 17.873887 },
  ATA: { lat: -75.250973, lng: -0.071389 },
  ARG: { lat: -38.416097, lng: -63.616672 },
  ASM: { lat: -14.270972, lng: -170.132217 },
  AUT: { lat: 47.516231, lng: 14.550072 },
  AUS: { lat: -25.274398, lng: 133.775136 },
  ABW: { lat: 12.52111, lng: -69.968338 },
  AZE: { lat: 40.143105, lng: 47.576927 },
  BIH: { lat: 43.915886, lng: 17.679076 },
  BRB: { lat: 13.193887, lng: -59.543198 },
  BGD: { lat: 23.684994, lng: 90.356331 },
  BEL: { lat: 50.503887, lng: 4.469936 },
  BFA: { lat: 12.238333, lng: -1.561593 },
  BGR: { lat: 42.733883, lng: 25.48583 },
  BHR: { lat: 25.930414, lng: 50.637772 },
  BDI: { lat: -3.373056, lng: 29.918886 },
  BEN: { lat: 9.30769, lng: 2.315834 },
  BMU: { lat: 32.321384, lng: -64.75737 },
  BRN: { lat: 4.535277, lng: 114.727669 },
  BOL: { lat: -16.290154, lng: -63.588653 },
  BRA: { lat: -14.235004, lng: -51.92528 },
  BHS: { lat: 25.03428, lng: -77.39628 },
  BTN: { lat: 27.514162, lng: 90.433601 },
  BVT: { lat: -54.423199, lng: 3.413194 },
  BWA: { lat: -22.328474, lng: 24.684866 },
  BLR: { lat: 53.709807, lng: 27.953389 },
  BLZ: { lat: 17.189877, lng: -88.49765 },
  CAN: { lat: 56.130366, lng: -106.346771 },
  CCK: { lat: -12.164165, lng: 96.870956 },
  COD: { lat: -4.038333, lng: 21.758664 },
  CAF: { lat: 6.611111, lng: 20.939444 },
  COG: { lat: -0.228021, lng: 15.827659 },
  CHE: { lat: 46.818188, lng: 8.227512 },
  CIV: { lat: 7.539989, lng: -5.54708 },
  COK: { lat: -21.236736, lng: -159.777671 },
  CHL: { lat: -35.675147, lng: -71.542969 },
  CMR: { lat: 7.369722, lng: 12.354722 },
  CHN: { lat: 35.86166, lng: 104.195397 },
  COL: { lat: 4.570868, lng: -74.297333 },
  CRI: { lat: 9.748917, lng: -83.753428 },
  CUB: { lat: 21.521757, lng: -77.781167 },
  CPV: { lat: 16.002082, lng: -24.013197 },
  CXR: { lat: -10.447525, lng: 105.690449 },
  CYP: { lat: 35.126413, lng: 33.429859 },
  CZE: { lat: 49.817492, lng: 15.472962 },
  DEU: { lat: 51.165691, lng: 10.451526 },
  DJI: { lat: 11.825138, lng: 42.590275 },
  DNK: { lat: 56.26392, lng: 9.501785 },
  DMA: { lat: 15.414999, lng: -61.370976 },
  DOM: { lat: 18.735693, lng: -70.162651 },
  DZA: { lat: 28.033886, lng: 1.659626 },
  ECU: { lat: -1.831239, lng: -78.183406 },
  EST: { lat: 58.595272, lng: 25.013607 },
  EGY: { lat: 26.820553, lng: 30.802498 },
  ESH: { lat: 24.215527, lng: -12.885834 },
  ERI: { lat: 15.179384, lng: 39.782334 },
  ESP: { lat: 40.463667, lng: -3.74922 },
  ETH: { lat: 9.145, lng: 40.489673 },
  FIN: { lat: 61.92411, lng: 25.748151 },
  FJI: { lat: -16.578193, lng: 179.414413 },
  FLK: { lat: -51.796253, lng: -59.523613 },
  FSM: { lat: 7.425554, lng: 150.550812 },
  FRO: { lat: 61.892635, lng: -6.911806 },
  FRA: { lat: 46.227638, lng: 2.213749 },
  GAB: { lat: -0.803689, lng: 11.609444 },
  GBR: { lat: 55.378051, lng: -3.435973 },
  GRD: { lat: 12.262776, lng: -61.604171 },
  GEO: { lat: 42.315407, lng: 43.356892 },
  GUF: { lat: 3.933889, lng: -53.125782 },
  GGY: { lat: 49.465691, lng: -2.585278 },
  GHA: { lat: 7.946527, lng: -1.023194 },
  GIB: { lat: 36.137741, lng: -5.345374 },
  GRL: { lat: 71.706936, lng: -42.604303 },
  GMB: { lat: 13.443182, lng: -15.310139 },
  GIN: { lat: 9.945587, lng: -9.696645 },
  GLP: { lat: 16.995971, lng: -62.067641 },
  GNQ: { lat: 1.650801, lng: 10.267895 },
  GRC: { lat: 39.074208, lng: 21.824312 },
  SGS: { lat: -54.429579, lng: -36.587909 },
  GTM: { lat: 15.783471, lng: -90.230759 },
  GUM: { lat: 13.444304, lng: 144.793731 },
  GNB: { lat: 11.803749, lng: -15.180413 },
  GUY: { lat: 4.860416, lng: -58.93018 },
  HKG: { lat: 22.396428, lng: 114.109497 },
  HMD: { lat: -53.08181, lng: 73.504158 },
  HND: { lat: 15.199999, lng: -86.241905 },
  HRV: { lat: 45.1, lng: 15.2 },
  HTI: { lat: 18.971187, lng: -72.285215 },
  HUN: { lat: 47.162494, lng: 19.503304 },
  IDN: { lat: -0.789275, lng: 113.921327 },
  IRL: { lat: 53.41291, lng: -8.24389 },
  ISR: { lat: 31.046051, lng: 34.851612 },
  IMN: { lat: 54.236107, lng: -4.548056 },
  IND: { lat: 20.593684, lng: 78.96288 },
  IOT: { lat: -6.343194, lng: 71.876519 },
  IRQ: { lat: 33.223191, lng: 43.679291 },
  IRN: { lat: 32.427908, lng: 53.688046 },
  ISL: { lat: 64.963051, lng: -19.020835 },
  ITA: { lat: 41.87194, lng: 12.56738 },
  JEY: { lat: 49.214439, lng: -2.13125 },
  JAM: { lat: 18.109581, lng: -77.297508 },
  JOR: { lat: 30.585164, lng: 36.238414 },
  JPN: { lat: 36.204824, lng: 138.252924 },
  KEN: { lat: -0.023559, lng: 37.906193 },
  KGZ: { lat: 41.20438, lng: 74.766098 },
  KHM: { lat: 12.565679, lng: 104.990963 },
  KIR: { lat: -3.370417, lng: -168.734039 },
  COM: { lat: -11.875001, lng: 43.872219 },
  KNA: { lat: 17.357822, lng: -62.782998 },
  PRK: { lat: 40.339852, lng: 127.510093 },
  KOR: { lat: 35.907757, lng: 127.766922 },
  KWT: { lat: 29.31166, lng: 47.481766 },
  CYM: { lat: 19.513469, lng: -80.566956 },
  KAZ: { lat: 48.019573, lng: 66.923684 },
  LAO: { lat: 19.85627, lng: 102.495496 },
  LBN: { lat: 33.854721, lng: 35.862285 },
  LCA: { lat: 13.909444, lng: -60.978893 },
  LIE: { lat: 47.166, lng: 9.555373 },
  LKA: { lat: 7.873054, lng: 80.771797 },
  LBR: { lat: 6.428055, lng: -9.429499 },
  LSO: { lat: -29.609988, lng: 28.233608 },
  LTU: { lat: 55.169438, lng: 23.881275 },
  LUX: { lat: 49.815273, lng: 6.129583 },
  LVA: { lat: 56.879635, lng: 24.603189 },
  LBY: { lat: 26.3351, lng: 17.228331 },
  MAR: { lat: 31.791702, lng: -7.09262 },
  MCO: { lat: 43.750298, lng: 7.412841 },
  MDA: { lat: 47.411631, lng: 28.369885 },
  MNE: { lat: 42.708678, lng: 19.37439 },
  MDG: { lat: -18.766947, lng: 46.869107 },
  MHL: { lat: 7.131474, lng: 171.184478 },
  MKD: { lat: 41.608635, lng: 21.745275 },
  MLI: { lat: 17.570692, lng: -3.996166 },
  MMR: { lat: 21.913965, lng: 95.956223 },
  MNG: { lat: 46.862496, lng: 103.846656 },
  MAC: { lat: 22.198745, lng: 113.543873 },
  MNP: { lat: 17.33083, lng: 145.38469 },
  MTQ: { lat: 14.641528, lng: -61.024174 },
  MRT: { lat: 21.00789, lng: -10.940835 },
  MSR: { lat: 16.742498, lng: -62.187366 },
  MLT: { lat: 35.937496, lng: 14.375416 },
  MUS: { lat: -20.348404, lng: 57.552152 },
  MDV: { lat: 3.202778, lng: 73.22068 },
  MWI: { lat: -13.254308, lng: 34.301525 },
  MEX: { lat: 23.634501, lng: -102.552784 },
  MYS: { lat: 4.210484, lng: 101.975766 },
  MOZ: { lat: -18.665695, lng: 35.529562 },
  NAM: { lat: -22.95764, lng: 18.49041 },
  NCL: { lat: -20.904305, lng: 165.618042 },
  NER: { lat: 17.607789, lng: 8.081666 },
  NFK: { lat: -29.040835, lng: 167.954712 },
  NGA: { lat: 9.081999, lng: 8.675277 },
  NIC: { lat: 12.865416, lng: -85.207229 },
  NLD: { lat: 52.132633, lng: 5.291266 },
  NOR: { lat: 60.472024, lng: 8.468946 },
  NPL: { lat: 28.394857, lng: 84.124008 },
  NRU: { lat: -0.522778, lng: 166.931503 },
  NIU: { lat: -19.054445, lng: -169.867233 },
  NZL: { lat: -40.900557, lng: 174.885971 },
  OMN: { lat: 21.512583, lng: 55.923255 },
  PAN: { lat: 8.537981, lng: -80.782127 },
  PER: { lat: -9.189967, lng: -75.015152 },
  PYF: { lat: -17.679742, lng: -149.406843 },
  PNG: { lat: -6.314993, lng: 143.95555 },
  PHL: { lat: 12.879721, lng: 121.774017 },
  PAK: { lat: 30.375321, lng: 69.345116 },
  POL: { lat: 51.919438, lng: 19.145136 },
  SPM: { lat: 46.941936, lng: -56.27111 },
  PCN: { lat: -24.703615, lng: -127.439308 },
  PRI: { lat: 18.220833, lng: -66.590149 },
  PSE: { lat: 31.952162, lng: 35.233154 },
  PRT: { lat: 39.399872, lng: -8.224454 },
  PLW: { lat: 7.51498, lng: 134.58252 },
  PRY: { lat: -23.442503, lng: -58.443832 },
  QAT: { lat: 25.354826, lng: 51.183884 },
  REU: { lat: -21.115141, lng: 55.536384 },
  ROU: { lat: 45.943161, lng: 24.96676 },
  SRB: { lat: 44.016521, lng: 21.005859 },
  RUS: { lat: 61.52401, lng: 105.318756 },
  RWA: { lat: -1.940278, lng: 29.873888 },
  SAU: { lat: 23.885942, lng: 45.079162 },
  SLB: { lat: -9.64571, lng: 160.156194 },
  SYC: { lat: -4.679574, lng: 55.491977 },
  SDN: { lat: 12.862807, lng: 30.217636 },
  SWE: { lat: 60.128161, lng: 18.643501 },
  SGP: { lat: 1.352083, lng: 103.819836 },
  SHN: { lat: -24.143474, lng: -10.030696 },
  SVN: { lat: 46.151241, lng: 14.995463 },
  SJM: { lat: 77.553604, lng: 23.670272 },
  SVK: { lat: 48.669026, lng: 19.699024 },
  SLE: { lat: 8.460555, lng: -11.779889 },
  SMR: { lat: 43.94236, lng: 12.457777 },
  SEN: { lat: 14.497401, lng: -14.452362 },
  SOM: { lat: 5.152149, lng: 46.199616 },
  SUR: { lat: 3.919305, lng: -56.027783 },
  STP: { lat: 0.18636, lng: 6.613081 },
  SLV: { lat: 13.794185, lng: -88.89653 },
  SYR: { lat: 34.802075, lng: 38.996815 },
  SWZ: { lat: -26.522503, lng: 31.465866 },
  TCA: { lat: 21.694025, lng: -71.797928 },
  TCD: { lat: 15.454166, lng: 18.732207 },
  ATF: { lat: -49.280366, lng: 69.348557 },
  TGO: { lat: 8.619543, lng: 0.824782 },
  THA: { lat: 15.870032, lng: 100.992541 },
  TJK: { lat: 38.861034, lng: 71.276093 },
  TKL: { lat: -8.967363, lng: -171.855881 },
  TLS: { lat: -8.874217, lng: 125.727539 },
  TKM: { lat: 38.969719, lng: 59.556278 },
  TUN: { lat: 33.886917, lng: 9.537499 },
  TON: { lat: -21.178986, lng: -175.198242 },
  TUR: { lat: 38.963745, lng: 35.243322 },
  TTO: { lat: 10.691803, lng: -61.222503 },
  TUV: { lat: -7.109535, lng: 177.64933 },
  TWN: { lat: 23.69781, lng: 120.960515 },
  TZA: { lat: -6.369028, lng: 34.888822 },
  UKR: { lat: 48.379433, lng: 31.16558 },
  UGA: { lat: 1.373333, lng: 32.290275 },
  USA: { lat: 37.09024, lng: -95.712891 },
  URY: { lat: -32.522779, lng: -55.765835 },
  UZB: { lat: 41.377491, lng: 64.585262 },
  VAT: { lat: 41.902916, lng: 12.453389 },
  VCT: { lat: 12.984305, lng: -61.287228 },
  VEN: { lat: 6.42375, lng: -66.58973 },
  VGB: { lat: 18.420695, lng: -64.639968 },
  VIR: { lat: 18.335765, lng: -64.896335 },
  VNM: { lat: 14.058324, lng: 108.277199 },
  VUT: { lat: -15.376706, lng: 166.959158 },
  WLF: { lat: -13.768752, lng: -177.156097 },
  WSM: { lat: -13.759029, lng: -172.104629 },
  YEM: { lat: 15.552727, lng: 48.516388 },
  MYT: { lat: -12.8275, lng: 45.166244 },
  ZAF: { lat: -30.559482, lng: 22.937506 },
  ZMB: { lat: -13.133897, lng: 27.849332 },
  ZW: { lat: -19.015438, lng: 29.154857 },
}
